<template>
  <div>
    <b-form-group label="Предмет ЕГЭ">
      <span role="button" @click="changeSubjects">
        <MultiSelect
          :value="filters.subject"
          :multiple="true"
          :options="subjects"
          label="summary"
          :disabled="true"
        />
      </span>
    </b-form-group>
    <b-form-group label="Город">
      <MultiSelect
        :value="filters.city"
        :multiple="true"
        :options="cities"
        @input="onSelectCity"
      />
    </b-form-group>
    <b-form-group label="Направления">
      <MultiSelect
        :value="filters.direction"
        :options="sortedDirections"
        label="codeTitle"
        :multiple="true"
        :groupSelect="true"
        groupLabel="codeTitle"
        groupValues="directions"
        trackBy="id"
        @input="onSelectDirection"
      />
    </b-form-group>
    <b-form-group label="Показать бонусы от олимпиад">
      <MultiSelect
        :value="filters.olympiad"
        :multiple="true"
        :options="olympiads"
        label="title"
        trackBy="id"
        @input="onSelectOlympiad"
      />
    </b-form-group>
    <b-form-checkbox class="mt-2" v-model="filters.isPaid">
      Платное обучение
    </b-form-checkbox>
    <ExamFilterModal :editData="subjects" @save="onSubjectFilterUpdate" />
  </div>
</template>

<script>
import _ from 'lodash'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import ExamFilterModal from '@/components/common/university/ExamFilterModal.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'UniversityFilters',
  components: {
    MultiSelect,
    ExamFilterModal
  },
  props: {
    directions: {
      type: Array,
      default() {
        return []
      }
    },
    cities: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      filters: {
        direction: [],
        olympiad: [],
        subject: [],
        city: [],
        isPaid: true
      },
      subjects: [],
      olympiads: []
    }
  },
  watch: {
    filters: {
      deep: true,
      handler(data) {
        this.$emit('filter', data)
      }
    }
  },
  computed: {
    sortedDirections() {
      const sortedDirections = _.sortBy(this.directions.map((gd) => ({
        ...gd,
        codeTitle: `${gd.code} ${gd.title}`
      })), 'code')
      for (const directionGroup of sortedDirections) {
        directionGroup.directions = _.sortBy(_.uniqBy(directionGroup.directions, 'educationDirection.id')
          .map((d) => ({
            ...d,
            codeTitle: `${d.educationDirection.code} ${d.educationDirection.title}`
          })), 'code')
      }
      return sortedDirections
    }
  },
  async created() {
    const response = await RecommendationAPI.getOlympiads()
    this.olympiads = response.data
  },
  methods: {
    changeSubjects() {
      this.$bvModal.show('examFilterModal')
    },
    redrawSubjects(subjects) {
      return subjects
        .filter((s) => s.subject)
        .map((s) => ({ ...s, summary: `${s.subject.name} ${s.addMark}` }))
    },
    onSelectCity(obj) {
      this.filters.city = obj
    },
    onSelectOlympiad(obj) {
      this.filters.olympiad = obj
    },
    onSelectDirection(obj) {
      this.filters.direction = obj
    },
    onSubjectFilterUpdate(data) {
      this.subjects = this.redrawSubjects(data)
      this.filters.subject = this.subjects
    }
  }
}
</script>

<style scoped>
.multiselect--disabled {
  opacity: 1 !important;
}
</style>
